const JsaStoreModule = {
    //namespaced: true,

    state: {
        jsa: {},
        hazardlist: {},
        controls: {},
        racLevels: {},
    },

    mutations: {

        putJsa(state, payload){
            state.jsa = payload;
            state.jsa = { ...state.jsa };
        },

        putHazards(state, payload) {
            state.hazardlist = payload;
        },

        putControls(state, payload) {
            state.controls = payload;
        },

        putRacLevels(state, payload) {
            state.racLevels = payload;
        },



    },
    actions: {

    },
}

export default JsaStoreModule;

